// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as VehicleFareEstimateInputModuleScss from "../styles/VehicleFareEstimateInput.module.scss";

var defaultStyles = VehicleFareEstimateInputModuleScss;

function VehicleFareEstimateInputCmp(Props) {
  var label = Props.label;
  var is_required = Props.is_required;
  var children = Props.children;
  var error = Props.error;
  var stylesOpt = Props.styles;
  var classNameOpt = Props.className;
  var styles = stylesOpt !== undefined ? Caml_option.valFromOption(stylesOpt) : defaultStyles;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("div", {
              className: "" + styles.container + " " + className + ""
            }, React.createElement("div", {
                  className: styles["input-container"]
                }, React.createElement("label", {
                      className: "" + (
                        is_required ? styles["label-required"] : styles.label
                      ) + " \n            " + (
                        Belt_Option.isSome(error) ? styles.error : ""
                      ) + "",
                      htmlFor: label
                    }, label), children), error !== undefined ? React.createElement("div", {
                    className: styles["error-container"]
                  }, error) : null);
}

var make = VehicleFareEstimateInputCmp;

export {
  defaultStyles ,
  make ,
}
/* defaultStyles Not a pure module */
